import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import events from '../src/events'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

let formats = {
  agendaDateFormat: 'MMMM DD'
};

function CalendarApp() {
  return (
    <div>
      <Calendar
        length='3650'
        events={events}
        localizer={localizer}
        style={{ height: 500 }}
        defaultView='agenda'
        formats={formats}
      //jeb defaultDate={new Date(2015, 3, 1)}
      />

      <br />
      <div class="container">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-11">
            <a title="Performances" href="venues">
              Where else do we play?<br />
              Check out our past performances.
            </a>
          </div>
        </div>
      </div>
      <br />

      {/* <Calendar
        events={events}
        localizer={localizer}
        formats={formats}
      //jebjeb
      /> */}
    </div>
  );
}

export default CalendarApp;